import pv from 'password-validator';
import { isEmpty } from 'lodash';

const passwordValidator = (newPassword) => {
  const passSchema = new pv()
      .is().min(6)
      .is().max(30)
      .has().uppercase(1)
      .has().symbols(1)
      .has().digits(1)
      .has().not().spaces()
      .is().not().oneOf([
        'Passw0rd',
        'Password123',
        '1234567890',
        '0123456789',
        "qwerty",
        "password111"
      ]);

  const passVal = passSchema.validate(newPassword, { list: true });

  if (!isEmpty(passVal)) {
    return {
      result: false,
      errorMessage: 'Password must be at least 6 characters long, have one symbol, capital letter, and one number, have no spaces, and be unique'
    }
  } else {
    return {
      result: true
    };
  }
}

export default passwordValidator;
